module.exports = __webpack_public_path__ + "static/media/U1_NORM.194970dc.png";